export default __webpack_public_path__ + "static/media/wayfarer.624f776a.png";